import { chartKeys } from 'utils/constant';

const profit_if_adding_to_negative_positions = {
  chartTitle: "Profit if adding to negative position(s)",
  chartKey: chartKeys.PROFIT_IF_ADDING_TO_NEGATIVE_POSITIONS,
  hoverTextArray: {
    pips: [
      {
        templateString: "",
        valueKey: "pips",
        unit: "pips",
        // textColor: function (hoveredData) {
        //   return hoveredData.pips >= 0 ? "#56A07E" : "#C15357";
        // },
        followBarColor: true,
      },
      {
        templateString: "",
        valueKey: "profit",
        unit: "USD",
        // textColor: function(hoveredData) {
        //   return hoveredData.profit >= 0? "#56A07E" : "#C15357"
        // },
        followBarColor: true,
      },
      {
        templateString: "Trades: ",
        valueKey: "trades",
      },
    ],
    percentage: [
      {
        templateString: "",
        valueKey: "percentage",
        unit: "%",
        // textColor: function (hoveredData) {
        //   return hoveredData.percentage >= 0 ? "#56A07E" : "#C15357";
        // },
        followBarColor: true,
      },
      {
        templateString: "",
        valueKey: "profit",
        unit: "USD",
        // textColor: function(hoveredData) {
        //   return hoveredData.profit >= 0? "#56A07E" : "#C15357"
        // },
        followBarColor: true,
      },
      {
        templateString: "Trades: ",
        valueKey: "trades",
      },
    ],
  },
  createHoverTextArray: (currency) => {
    return {
      pips: [
        {
          templateString: "",
          valueKey: "pips",
          unit: "pips",
          // textColor: function (hoveredData) {
          //   return hoveredData.pips >= 0 ? "#56A07E" : "#C15357";
          // },
          followBarColor: true,
        },
        {
          templateString: "",
          valueKey: "profit",
          unit: currency,
          // textColor: function(hoveredData) {
          //   return hoveredData.profit >= 0? "#56A07E" : "#C15357"
          // },
          followBarColor: true,
        },
        {
          templateString: "Trades: ",
          valueKey: "trades",
        },
      ],
      percentage: [
        {
          templateString: "",
          valueKey: "percentage",
          unit: "%",
          // textColor: function (hoveredData) {
          //   return hoveredData.percentage >= 0 ? "#56A07E" : "#C15357";
          // },
          followBarColor: true,
        },
        {
          templateString: "",
          valueKey: "profit",
          unit: currency,
          // textColor: function(hoveredData) {
          //   return hoveredData.profit >= 0? "#56A07E" : "#C15357"
          // },
          followBarColor: true,
        },
        {
          templateString: "Trades: ",
          valueKey: "trades",
        },
      ],
    }
  }
  // interval: ["average", "1", "2", "3", "4-5", "5+"],
}

export default profit_if_adding_to_negative_positions;